<template>
	<div>
		<h1>Trial Plan</h1>
		<i>
			The following document is a template that can be used to help with
			carrying out your proposed clinical trial. It is separate from the trial
			protocol and is recommended to be filled out after the protocol is
			completed and you are ready to begin the study. You may not be able to
			fill out the complete template at that time therefore it could be a living
			document that is completed during the conduct of the trial.
		</i>
		<InputSrTableCustom
			question="What is your Trial Plan?"
			v-model="$tera.project.TrialWizard.trialplanTable"
			:titlePageAuthors="Authors"
		></InputSrTableCustom>
	</div>
</template>
<script>
import InputSrTableCustom from "@/components/InputSrTableCustom.vue";
export default {
	name: "ViewMethodResearchPlan",
	components: {
		InputSrTableCustom
	},
	computed: {
		Authors() {
			let da = [];
			if (
				//check if authors are initialized
				this.$tera.project.author != undefined &&
				this.$tera.project.acknowledgements != undefined
			) {
				da = [...this.$tera.project.author, ...this.$tera.project.acknowledgements];
			}
			this.checkUnion(da);
			return da?.map(el => {
				return { label: el };
			});
		}
	},
	methods: {
		checkUnion(U) {
			if (U.length > 0) {
				for (var i = 0; i < U.length; i++) {
					for (var j = i + 1; j < U.length; j++) {
						if (U[i] == U[j]) {
							U.splice(j, 1);
							j--;
						}
					}
				}
			}
		}
	}
};
</script>
<style></style>
